import api from "../../../api/comptabilite/_proforma";

const state = () => ({
    fpro_consultations: [],
    facture_proformas: [],
    single_facture_proforma: [],
    proforma_type_prestation: [],
    fpro_analyse: [],
    fpro_examen: [],
    fpro_pharmacie: [],
    fpro_soins: [],
    fpro_chirurgie: [],
    fpro_autres: [],
});

// getters
const getters = {
    fpro_consultations: (state) => {
        return state.fpro_consultations;
    },

    facture_proformas: (state) => {
        return state.facture_proformas;
    },

    single_facture_proforma: (state) => {
        return state.single_facture_proforma;
    },

    proforma_type_prestation: (state) => {
        return state.proforma_type_prestation;
    },

    fpro_analyse: (state) => {
        return state.fpro_analyse;
    },

    fpro_examen: (state) => {
        return state.fpro_examen;
    },

    fpro_pharmacie: (state) => {
        return state.fpro_pharmacie;
    },

    fpro_soins: (state) => {
        return state.fpro_soins;
    },

    fpro_chirurgie: (state) => {
        return state.fpro_chirurgie;
    },

    fpro_autres: (state) => {
        return state.fpro_autres;
    },
};

// mutations
const mutations = {
    SET_FPRO_CONSULTATIONS(state, facture) {
        state.fpro_consultations = facture;
    },

    SET_FPRO_EXAMEN(state, facture) {
        state.fpro_examen = facture;
    },

    SET_FPRO_ANALYSE(state, facture) {
        state.fpro_analyse = facture;
    },

    SET_FPRO_PHARMACIE(state, facture) {
        state.fpro_pharmacie = facture;
    },

    SET_FPRO_SOINS(state, facture) {
        state.fpro_soins = facture;
    },

    SET_FPRO_CHIRURGIE(state, facture) {
        state.fpro_chirurgie = facture;
    },

    SET_FPRO_AUTRES(state, facture) {
        state.fpro_autres = facture;
    },

    SET_FACTURE_PROFORMAS(state, facture) {
        state.facture_proformas = facture;
    },

    SET_SINGLE_FACTURE_PROFORMA(state, facture) {
        state.single_facture_proforma = facture;
    },

    SET_PROFORMA_TYPE_PRESTATION(state, type_prestation) {
        state.proforma_type_prestation = type_prestation;
    },
};

// actions
const actions = {

    saveConsultationProforma({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationProforma(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    savePrestationProforma({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.savePrestationProforma(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveAutrePrestationProforma({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveAutrePrestationProforma(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListePrestationProforma({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListePrestationProforma(data).then(
                (response) => {
                    if (data.type_prestation == 'consultation') {
                        commit("SET_FPRO_CONSULTATIONS", response);
                    } else if (data.type_prestation == 'analyse') {
                        commit("SET_FPRO_ANALYSE", response);
                    } else if (data.type_prestation == 'examen') {
                        commit("SET_FPRO_EXAMEN", response);
                    } else if (data.type_prestation == 'medicament') {
                        commit("SET_FPRO_PHARMACIE", response);
                    } else if (data.type_prestation == 'soins') {
                        commit("SET_FPRO_SOINS", response);
                    }  else if (data.type_prestation == 'autre') {
                        commit("SET_FPRO_AUTRES", response);
                    } 
                    
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeChirurgieProforma({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeChirurgieProforma(data).then(
                (response) => {
                    commit("SET_FPRO_CHIRURGIE", response);
                    
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    removePrestationFromProforma({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removePrestationFromProforma(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getFactureProforma({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getFactureProforma(data).then(
                (response) => {
                    commit("SET_FACTURE_PROFORMAS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getSingleFactureProforma({ commit }, fproforma_id) {
        return new Promise((resolve, reject) => {
            api.getSingleFactureProforma(fproforma_id).then(
                (response) => {
                    commit("SET_SINGLE_FACTURE_PROFORMA", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getTypePrestationFactureProforma({ commit }, fproforma_id) {
        return new Promise((resolve, reject) => {
            api.getTypePrestationFactureProforma(fproforma_id).then(
                (response) => {
                    commit("SET_PROFORMA_TYPE_PRESTATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteFactureProforma({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteFactureProforma(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveProformaCommentaire({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveProformaCommentaire(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions,
};